module.exports = __webpack_public_path__ + "img/music.9da8284b.svg";